import { Button as AntdButton, Divider as BaseDivider, Table } from 'antd';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import BaseCheckbox from '@deprecated-ui/common/Checkbox';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import styled, { css } from 'styled-components';
import { InfoTable } from '../DetailModal/InfoTable';

interface DetailOrderButtonProps {
  variant?: 'amend' | 'cancel';
}

const CellLabel = styled(Text).attrs({
  color: color.midgray,
  size: '12px',
  align: 'inherit',
})``;

export const HeaderWrapper = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 60px;
`;

export const OrderTable = styled(Table)`
  width: 100%;
  max-width: 1250px;
  cursor: pointer;

  table {
    border-collapse: collapse;
  }

  .ant-table-thead > tr {
    height: 50px;

    & > th {
      padding: 0 8px;
      height: 17px;
      font-size: 14px;
      border-top: 1px solid ${color.gainsboro};
      border-bottom: 1px solid ${color.gainsboro};

      &:first-child {
        padding-left: 16px;
      }
      &:last-child {
        padding-right: 16px;
      }

      .ant-table-selection {
        display: flex;
      }
    }
  }

  .ant-checkbox-wrapper {
    vertical-align: middle;

    .ant-checkbox-indeterminate > .ant-checkbox-inner {
      border: 1px solid #00ab6b;
      background-color: #00ab6b;

      :after {
        background-color: #ffffff;
        height: 2px;
        border-radius: 1px;
      }
    }
  }

  .ant-empty-description {
    font-size: 12px;
    font-family: var(--regular-font);
    color: #0000006e;
  }

  .ant-btn[disabled] {
    background: white;
  }

  .ant-table-thead > tr > th {
    font-size: 14px;
    border-top: 1px solid ${color.gainsboro};
    border-bottom: 1px solid ${color.gainsboro};
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td:not(.td-mobile) {
    display: none;
  }

  .ant-table-content {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .ant-table-tbody > tr {
    height: 48px;

    &.ant-table-expanded-row {
      > td.ant-table-cell {
        background: #ffffff;
      }

      &.double {
        height: 96px;
      }

      .ant-table-content {
        overflow-x: unset !important;
      }
    }

    & > td {
      padding: 0 8px;
      border-bottom: 0;

      &:first-child {
        padding-left: 16px;
      }

      &:last-child {
        padding-right: 16px;
      }

      &.bracket-item:first-child {
        padding-left: 8px;
      }

      &.bracket-item:last-child {
        padding-right: 8px;
      }
    }
  }

  .ant-table-tbody > tr > .td-mobile:first-child {
    display: block;
    width: 100vw;
    border-width: 0;
    height: 25px;
  }

  /* Invested column */
  .ant-table-tbody > tr > td:nth-child(6) {
    text-align: left !important;
  }
  /* Action column */
  .ant-table-tbody > tr > td:last-child > div {
    height: 37px;
  }

  .ant-table-tbody > tr > .td-mobile {
    display: inline-block;
    width: calc(100vw / 4);
  }

  ${CellLabel} {
    display: block;
  }

  @media ${device.mobileL} {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td:not(.td-mobile) {
      display: table-cell;
    }

    .ant-table-content {
      overflow-x: auto;
    }

    .ant-table-tbody > tr > .td-mobile:first-child,
    .ant-table-tbody > tr > .td-mobile {
      display: table-cell;
      width: inherit;
      border-width: 1px;
    }

    /* Invested column */
    .ant-table-tbody > tr > td:nth-child(6) {
      text-align: right !important;
    }
    /* Action column */
    .ant-table-tbody > tr > td:last-child > div {
      height: unset;
    }

    & .ant-checkbox-wrapper {
      align-items: center;
      padding: 3px;

      & > .ant-checkbox {
        top: 0;

        & > .ant-checkbox-inner {
          width: 18px;
          height: 18px;
          border-radius: 4px;
        }
      }

      & > .ant-checkbox-checked::after {
        border-radius: 4px;
      }

      & > span:nth-child(2) {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }
    }

    ${CellLabel} {
      display: none;
    }
  }

  .ant-pagination {
    background: ${color.light};
    margin: 0px;
    padding: 16px 0 12px 20px;

    .ant-pagination-item,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      display: none;
    }
    .ant-pagination-item-link {
      height: 24px;
      border-radius: 0;
      padding: 0 8px;
      font-family: var(--regular-font);
      line-height: 100%;
      font-size: 12px;
      &.next-button {
        margin-left: -1px;
      }

      &:not([disabled]) {
        color: ${color.primary};
      }

      &:hover:not([disabled]) {
        color: ${color.primary};
        border: 1px solid ${color.primary};
      }
    }
  }
`;

export const ActionButton = styled(Button)`
  line-height: normal;
  height: unset;
`;

export const RejectedBox = styled.div`
  position: relative;
  width: 100%;
  padding: 18px 18px 20px;
  border: 1px solid #ff525244;
  margin-bottom: 16px;
`;

export const AutoOrderBadge = styled(Text).attrs({
  p: '3px 5px',
  family: 'bold',
  color: color.highgray,
  size: '8px',
  ml: '10px',
})`
  border: 1px solid #ededed;
  border-radius: 2px;
`;

export const OrderModalInfoTable = styled(InfoTable)`
  padding: 20px;
`;

export const Checkbox = styled(BaseCheckbox)`
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  height: 36px;
  align-items: center;
  margin-left: 0px !important;
  padding: 0 20px;

  span {
    padding: 0;
  }

  :hover {
    background: #f7f7f7;
  }
`;

export const OverlayDropdown = styled.div`
  width: 200px;
  background: ${color.light};
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  margin-top: 5px;
`;

export const FilterWrapper = styled.div`
  height: 280px;
  overflow-y: scroll;
  padding: 10px 0;
`;

export const FilterTitle = styled.b`
  line-height: 36px;
  height: 36px;
  padding: 0 20px;
  text-align: center;
`;

export const FilterButton = styled(Button)<{ type?: string }>`
  width: 90px;
  height: 35px;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin: 0 0 0 16px;
  ${({ type }) =>
    type === 'outline-primary' &&
    `
      color: ${color.primary};
      border-color: ${color.primary};
      > p {
        color: ${color.primary};
      }
    `};
`;

export const FilterAction = styled(Button)<{ type?: string }>`
  width: 78px;
  height: 28px;
  border-radius: 4px;
  font-weight: 700;

  ${({ type }) =>
    type === 'ghost' &&
    `
      color: #cceee1;
      border-color: #cceee1;
      cursor: not-allowed;
      :hover {
        color: #cceee1;
        border-color: #cceee1;
      }
    `};
`;

export const FilterActionWrapper = styled(Flex)`
  border-top: 1px solid ${color.downgray};
  justify-content: space-between;
  align-items: center;
  height: 53px;
  padding: 0 16px;
`;

export const Divider = styled(BaseDivider)`
  margin: 16px 0 10px;
`;

export const ShareTradeButton = styled(AntdButton)`
  height: 46px;
  color: #ffffff;
  border-radius: 4px;

  font-size: 18px;
  font-weight: 700;
`;

export const FooterActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

const detailOrderButtonStyles = {
  amend: css`
    border-color: #00ab6b;
    color: #00ab6b;
  `,
  cancel: css`
    border-color: #ee4a49;
    color: #ee4a49;
  `,
};

export const DetailOrderButton = styled.button<DetailOrderButtonProps>`
  flex: 1;
  border: 1px solid;
  background-color: transparent;

  font-size: 14px;
  line-height: 19px;
  font-weight: 700;

  border-radius: 4px;
  padding: 12px;
  min-height: 44px;

  cursor: pointer;
  opacity: 1;
  transition: opacity 0.15s ease-out;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 1;
  }

  ${({ variant = 'amend' }) => detailOrderButtonStyles[variant]};

  &:disabled {
    border: 1px solid #ccc;
    color: #ccc;
    cursor: not-allowed;
  }
`;

export const SymbolCell = styled.div`
  display: flex;
  align-items: center;

  &:hover .chevron-icon {
    visibility: visible;
  }

  &.children {
    position: relative;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      width: 9px;
      border-left: 1px solid #cbcbcb;
      border-bottom: 1px solid #cbcbcb;
      border-bottom-left-radius: 4px;
      top: var(--tree-top);
      left: -28px;
      height: var(--tree-height);
    }
  }

  .chevron-icon {
    visibility: hidden;
    margin-left: 8px;
  }
`;
